export const reviewsForVendorQuery = `
query GetReviewsForVendorByStorefrontId(
  $id: ID!
  $size: Int
  $page: Int
  $sort: Sort!
  $sortType: ReviewsOrderByType!
  $gallerySize: Int
) {
  reviews(
    input: {
      pagination: { page: $page, size: $size }
      filters: { storefrontId: $id, disputed: false }
      orderBy: { type: $sortType, sort: $sort }
    }
  ) {
    nodes {
      userVerified
      highlighted(storefrontId: $id)
      attributes {
        weddingDate
      }
      comment {
        active
        commenterId
        content
        createdAt
        id
        updatedAt
      }
      content
      createdAt
      id
      overallRating
      photos {
        active
        sourceId
        createdAt
        updatedAt
        name
        width
        height
      }
      reviewer {
        memberId
        firstName
        lastName
        role
      }
      title
      updatedAt
    }
    totalCount
  }
  summaryReviews(input: { storefrontId: $id }) {
    count
    distribution {
      stars1
      stars2
      stars3
      stars4
      stars5
    }
    rating
    ratings {
      flexibility
      professionalism
      quality
      responseTime
      value
    }
    gallery {
      photoCount
    }
  }
  reviewsPhotos(
    input: {
      storefrontId: $id
      size: $gallerySize
      filters: { disputed: false }
    }
  ) {
    reviewsPhotos {
      active
			sourceId
			createdAt
			updatedAt
			name
			width
			height
    }
  }
  reviewsWithPhotos: reviews(
    input: {
      pagination: { page: 1, size: 1 }
      filters: { storefrontId: $id, disputed: false, photos: true }
      orderBy: { type: $sortType, sort: $sort }
    }
  ) {
    totalCount
  }
  storefrontReviewSnippets: reviewSnippets(input: { storefrontId: $id }) {
    eligible
    snippets {
      reviewerName
      excerpt
      rating
      reviewDate
    }
    summary {
      averageRating
      totalReviewCount
    }
  }
}
`;

export const hasCurrentUserReviewedVendorQuery = `
query HasCurrentUserReviewedVendor($id: ID!) {
  hasCurrentUserReviewedVendor(input: { vendorId: $id }) {
    hasReviewed
  }
}
`;

export type ReviewsForVendor = {
	reviews: PaginatedReview;
	summaryReviews: SummaryReviews;
	reviewsPhotos: ReviewPhotoPayload;
	reviewsWithPhotos: {
		totalCount: number;
	};
	// Optional + nullable: field may be absent during rollout and may resolve to null.
	storefrontReviewSnippets?: StorefrontReviewSnippets | null;
};

export type HasCurrentUserReviewedVendor = {
	hasCurrentUserReviewedVendor: {
		hasReviewed: boolean;
	};
};

type PaginatedReview = {
	nodes: ReviewNode[];
	totalCount: number;
};

export type ReviewNode = {
	attributes: ReviewAttribute | null;
	comment: ReviewComment | null;
	content: string;
	createdAt: string;
	highlighted: boolean;
	id: string;
	overallRating: number | null;
	photos: ReviewPhoto[];
	reviewer: Reviewer;
	title: string;
	updatedAt: string;
	userVerified: boolean;
};

type ReviewAttribute = {
	weddingDate: string | null;
};

export type ReviewComment = {
	active: boolean;
	commenterId: string;
	content: string;
	createdAt: string;
	id: string;
	updatedAt: string;
};

export type ReviewPhoto = {
	active: boolean;
	createdAt: string;
	height: number | null;
	name: string | null;
	sourceId: string | null;
	updatedAt: string;
	width: number | null;
};

type Reviewer = {
	firstName: string | null;
	lastName: string | null;
	memberId: string | null;
	role: string | null;
};

export type SummaryReviews = {
	count: number;
	distribution: SummaryDistribution;
	rating: number;
	ratings: SummaryRatings;
	gallery: {
		photoCount: number;
	};
};

type SummaryDistribution = {
	stars1: number;
	stars2: number;
	stars3: number;
	stars4: number;
	stars5: number;
};

type SummaryRatings = {
	flexibility: number;
	professionalism: number;
	quality: number;
	responseTime: number;
	value: number;
};

type ReviewPhotoPayload = {
	reviewsPhotos: ReviewPhoto[];
};

export type StorefrontReviewSnippet = {
	reviewerName: string;
	excerpt: string;
	rating: number;
	reviewDate: string;
};

export type StorefrontReviewSnippetsSummary = {
	averageRating: number;
	totalReviewCount: number;
};

export type StorefrontReviewSnippets = {
	eligible: boolean;
	snippets: StorefrontReviewSnippet[];
	summary: StorefrontReviewSnippetsSummary | null;
};
